import Vue from 'vue'
import Change from './index.vue'
let TipsConstructor = Vue.extend(Change)

let changeStaking = function () {
  return new Promise((resolve, reject) => {
    let TipsDom = new TipsConstructor({
      el: document.createElement('div')
    })
    document.body.appendChild(TipsDom.$el)
  })
}
export default changeStaking

// 在需要的地方直接用以下方法调用即可：
// this.$tip(text, bool).then(() => {
//     console.log('ok')
// })
// .catch(() => {
// })



// WEBPACK FOOTER //
// ./src/components/changeStaking/index.js